import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { ValueDescription } from '../../../../../card/value-description/value-description';
import Skeleton from '../../../../skeleton';
import { CardTitle } from '../../../../../card/title/card-title';

export const SkeletonDashboardCardsRealizedProfit: React.FC = observer(() => {
    const { t } = useTranslation();

    return (
        <div className="relative flex h-full flex-col justify-between overflow-hidden rounded-large bg-body p-[1.6rem] shadow-strong lg:p-[2.2rem]">
            <CardTitle title={t('layout.statisticsCard.realizedProfit.title')} />
            <ValueDescription
                value={<Skeleton height={2.4} />}
                description={<Skeleton height={1.3} />}
                valueColor={'default'}
                padding={'none'}
            />
        </div>
    );
});
